import React from 'react';
import {
  Card,
  CardImg,
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  UncontrolledDropdown,
} from 'reactstrap';
import { Link } from "react-router-dom";
import SockJS from "sockjs-client";
import { Client } from '@stomp/stompjs';
import Lib from "../../../commons/lib";
import Services from './Services';
import Page404 from '../../Pages/Page404';
import { saveLocale, getLocale } from '../transInit';
import FlagIcon from 'react-flag-icon-css';
import './style.css';

let sockjs = null;

const setLocale = (locale) => (ev) => {
  ev.preventDefault();
  saveLocale(locale);
  window.location.reload();
}

export default class KioskPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      connected: false,
      type: 'NYITOOLDAL',
      sessionId: null,
      error: true,
      data: {},
    };

    // Ezek az eventek jelzik, hogy aktív a felhasználó
    this.eventList = ['mousemove', 'mousedown', 'mouseup', 'click', 'touchstart', 'touchend', 'touchcancel', 'touchmove'];
    this.inactivityThreshold = 30000;
    this.timer = null;

    /* Sorrend:
     Cím,
     szöveg,
     obj
     */
    this.menuBaseList = [
      [
        'Jegyvásárlás',
        'Itt lehetőséged van filmekre jegyet vásárolni!',
        'jegyvasarlas'
      ],
      [
        'Foglalás fizetése',
        'Meglévő foglalások véglegesítése és fizetése!',
        'foglalasfizetes'
      ],
      // [
      //   'Büfé vásárlás',
      //   'Válogasd össze szabadon a büfé menüdet!',
      //   'bufevasarlas'
      // ],
      // [
      //   'Információk',
      //   'Tudj meg többet a filmkínálatról és a moziról!',
      //   'informaciok'
      // ],
      // [
      //   'Törzskártya és Ajándékjegy vásárlás',
      //   'Ajándékozz mozijegyet vagy legyél a törzsvendégünk speciális kedvezményekért!',
      //   'torzsajandek'
      // ]
    ];
  }

  componentDidMount() {
    window.addEventListener("beforeunload", (e) => this.deleteSession(e), false);
    window.addEventListener("popstate", (e) => this.deleteSession(e), false);
    this.renderToken();
    this.init();
    // this.addTimer();
    this.setCSS();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this.removeTimer();
    this.removeCSS();
  }

  addTimer = () => {
    this.setTimer();
    this.eventList.forEach((event) => {
      window.addEventListener(event, this.resetTimer);
    });
  }

  removeTimer = () => {
    this.clearTimer();
    this.eventList.forEach((event) => {
      window.removeEventListener(event, this.resetTimer);
    });
  }

  clearTimer = () => {
    clearTimeout(this.timer);
  }

  resetTimer = () => {
    if (this.state.type != 'NYITOOLDAL')
      this.setState({ type: 'NYITOOLDAL' });
    this.clearTimer();
    this.timer = this.setTimer();
  }

  setTimer = () => {
    return setTimeout(this.timeout, this.inactivityThreshold);
  }

  timeout = () => {
    if (this.state.type != 'REKLAM') {
      this.setState({ type: 'REKLAM' });
    }
  }

  // A setCSS változtatásait vissza kell vonni a removeCSS-ben
  setCSS = () => {
    document.body.classList.add('kioskBackground');
  }

  removeCSS = () => {
    document.body.classList.remove('kioskBackground');
  }

  init = () => {
    Services.KIOSKinit(this.props.match.params.eszkozazonosito, (err, res) => {
      if (!err) {
        this.setState({
          data: res[0]
        });
      }
    });
  }

  deleteSession = () => {
    if (sockjs) {
      Services.deleteSession(this.state.sessionId, (err, res) => {
        if (!err) {
        }
      });
    }
  }

  msConversion = (millis) => {
    let sec = Math.floor(millis / 1000);
    let hrs = Math.floor(sec / 3600);
    sec -= hrs * 3600;
    let min = Math.floor(sec / 60);
    sec -= min * 60;

    sec = '' + sec;
    sec = ('00' + sec).substring(sec.length);

    if (hrs > 0) {
      min = '' + min;
      min = ('00' + min).substring(min.length);
      return min;
    }
    else {
      return min;
    }
  }

  renderToken = () => {
    if (!this.state.connected) {
      let clientId = Lib.MicroServices.keycloak.clientId;
      this.client = new Client();

      const randomString = (length = 10) => Math.random().toString(20).substr(2, length);
      const sessionId = randomString();

      sockjs = new SockJS(window.location.origin + "/api/helyszin/public/ws?eszkozazonosito=" + this.props.match.params.eszkozazonosito + "&wsclientid=" + clientId, [], {
        sessionId: () => {
          return sessionId;
        }
      });

      this.client.webSocketFactory = function () {
        return sockjs;
      };

      this.client.configure({
        onConnect: () => {
          // console.log(sessionId);
          this.setState({
            connected: true,
            sessionId: sessionId,
            error: false
          });
          this.client.subscribe('/user/' + this.state.sessionId + '/kiosk', message => {
            // console.log('------', JSON.parse(message.body).payload.type)
            switch (JSON.parse(message.body).payload.type) {
              case 'NYITOOLDAL':
                this.setState({
                  type: JSON.parse(message.body).payload.type
                });
                break;
              case 'REKLAM':
                this.setState({
                  type: JSON.parse(message.body).payload.type,
                });
                break;
              default:
                break;
            }
          });
        },
        // debug: (str) => {
        //   console.log(new Date(), str);
        // }
      });
      this.client.activate();
    }
  }

  renderReklam = () => {
    return <div style={{ color: 'white' }}>
      Reklám!
    </div>;
  }

  renderNyitoOldal = () => {
    return <div style={{ textAlign: 'center', paddingTop: 10 }}>
      {this.renderHeader()}
      {this.renderMenu()}
      {this.renderFooter()}
    </div>
  }

  renderHeader = () => {
    return <div>
      {this.renderLogo()}
      {this.renderHeaderSzoveg()}
      {this.renderNyelvValaszto()}
    </div>;
  }

  renderNyelvValaszto = () => {
    return <div className='nyitoNyelvValaszto'>
      <Navbar expand="md" >
        <NavbarToggler onClick={this.toggle}>
          <i className="fa fa-navicon" />
        </NavbarToggler>
        <Collapse navbar>
          <Nav className="ml-auto" navbar>
            <UncontrolledDropdown nav inNavbar style={{ marginRight: 10 }}>
              {/* nyitoFlagDiv-vel meg van növelve, hogy könnyebb legyen rákattintani érintőképernyőn */}
              <DropdownToggle nav caret className='nyitoFlagDiv'>
                <span className={"nyitoFlag flag-icon flag-icon-" + (getLocale() === 'en' ? 'gb' : getLocale())} />
              </DropdownToggle>
              <DropdownMenu end>
                <DropdownItem onClick={setLocale('hu')}>
                  <span className="flag-icon flag-icon-hu" />
                  {' Magyar'}
                </DropdownItem>
                <DropdownItem onClick={setLocale('en')}>
                  <span className="flag-icon flag-icon-gb" />
                  {' English'}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown>
              <DropdownMenu end>
                <DropdownItem header className="text-center"><strong>Fiók</strong></DropdownItem>
                <DropdownItem onClick={this.toggleFullscreen} className="nav-head">
                  <i className="fa fa-arrows-alt" />
                  {'Teljes képernyő ki/be'}
                </DropdownItem>
                <DropdownItem onClick={this.logout} className="nav-head">
                  <i className="fa fa-lock" />
                  {'Kilépés'}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  }

  renderLogo = () => {
    const { data } = this.state;
    let content = '';
    if (data.helyszinlogo) {
      content = data.helyszinlogo.src ? data.helyszinlogo.src : "data:image/bmp;base64," + data.helyszinlogo.content;
    }
    return <Card className='nyitoHeader kioskBackground' style={{ borderStyle: 'none' }}>
      <CardImg
        src={content}
        className='nyitoLogo'
      />
    </Card>
  }

  renderHeaderSzoveg = () => {
    const { data } = this.state;
    return <div className='nyitoHeader nyitoHeaderSzoveg'>
      {data.helyszinnev}
    </div>
  }

  renderMenu = () => {
    const { data } = this.state;
    let menu = [];
    for (let i = 0; i < this.menuBaseList.length; i++) {
      const listItem = this.menuBaseList[i];
      let link = data[listItem[2]];
      menu.push(
        <Link
          to={link ? 'http://' + link + '&lang=' + getLocale() : ''}
          class='nyitoLink'
        >
          <div class="nyitoGomb">
            <div class="nyitoGombCim">
              {listItem[0]}
            </div>
            <div class="nyitoGombSzoveg">
              {listItem[1]}
            </div>
          </div>
        </Link>
      );
    }
    return <div className='menu'>
      {menu}
    </div>;
  }

  renderFooter = () => {
    const { data } = this.state;
    return <div className='nyitoFooter'>
      <div>
        {data.cim}
        {data.telefon ? ', Tel: ' + data.telefon : ''}
      </div>
      {data.telefon ?
        <div>
          E-mail: {data.email}, {data.ido}
        </div>
        : <div />}
    </div>
  }

  render() {
    return (
      <div>
        {!this.state.error ? (
          <div className="animated fadeIn" style={{ height: 'auto' }}>
            {{
              REKLAM: (this.renderReklam()),
              NYITOOLDAL: (this.renderNyitoOldal()),
            }[this.state.type]}
          </div>
        ) : (
            <Page404 />
          )}
      </div>
    )
  }
}
